export const ADD_TO_CALENDAR_PATH = '/add-to-calendar';
